import { ApplyModalContainer as ApplySubmodal } from '@percent/cause-dashboard/app/productOffersDetail/applyModal/ApplyModalContainer'
import { useTranslation } from 'react-i18next'
import { useSmartApplyVariant } from '@percent/cause-dashboard/common/hooks/useSmartApplyVariant'
import { useEnabledSmartApplyPartners } from '@percent/cause-dashboard/common/hooks/useEnabledSmartApplyPartners/useEnabledSmartApplyPartners'
import type { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartnerConfig'

type SmartApplyRouterProps = {
  selectedPartner: SmartApplyPartner | null
  onClose: () => void
  onSuccess: () => void
  experimentVariantOverride?: string
}

export function SmartApplyRouter({
  selectedPartner,
  onClose,
  onSuccess,
  experimentVariantOverride
}: Readonly<SmartApplyRouterProps>) {
  const { t } = useTranslation()
  const { getExperimentVariant } = useSmartApplyVariant()
  const experimentVariant = experimentVariantOverride ?? getExperimentVariant()
  const { isPartnerEnabled, getConfig } = useEnabledSmartApplyPartners()

  if (!selectedPartner || !isPartnerEnabled(selectedPartner)) {
    return null
  }

  const config = getConfig(selectedPartner)

  return (
    <ApplySubmodal
      isOpen={true}
      handleClose={onClose}
      onSuccess={onSuccess}
      image={config.modalImage}
      source="smart-apply"
      partner={selectedPartner}
      experimentVariant={experimentVariant}
      modalTitle={String(t(config.i18n.modal.title as never))}
      modalDescription={String(t(config.i18n.modal.description as never))}
      disclaimer={String(t(config.i18n.modal.disclaimer as never))}
      externalApplyUrl={config.externalApplyUrl}
      products={config.products.map(p => ({
        name: p.name,
        displayName: String(t(p.displayNameKey as never)),
        description: String(t(p.descriptionKey as never)),
        logo: p.logo,
        isOptional: p.isOptional
      }))}
    />
  )
}
